import moment from 'moment';

import { SearchThreadCreationRequest } from '../../../../../gamma-api';

export const buildThreadCreationRequest = (projectId: string): SearchThreadCreationRequest => ({
  project_id: projectId,
  name: `Testing thread ${moment().toISOString()}`,
});
